const urls = {
  /**
   * 进入聊天室
   * roomId: 群聊id (列表的id)
   */
  enterChatRoom: 'post /teacherTalk/enter',
  /**
   * 加入群聊
   * sourceId: 群聊id
   * ukey: app或者小程序的用户token
   */
  joinChatRoom: 'get /room/login',
  /**
   * 用户发消息
   * userId: login接口返回的user.id,sourceId,msgType,content
   */
  commonSend: 'post /room/commonSend'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${arr[1]}`
}
export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/jindashi-api.js